// @ts-strict-ignore
import {DisplaySize, Placement} from 'common/components/tooltip/types';
import {TooltipAttrs} from 'common/components/tooltip/types';
import {AnalysisType, ChartType} from 'common/types/reports/bookmark';
import pieSvg from 'common/assets/images/charts/pie.svg';
import barSvg from 'common/assets/images/charts/bar.svg';
import lineSvg from 'common/assets/images/charts/line.svg';
import columnSvg from 'common/assets/images/charts/column.svg';
import stackedBarSvg from 'common/assets/images/charts/stacked-bar.svg';
import stackedLineSvg from 'common/assets/images/charts/stacked-line.svg';
import stackedColumnSvg from 'common/assets/images/charts/stacked-column.svg';
import rollingLineSvg from 'common/assets/images/charts/rolling-line.svg';
import rollingStackedLineSvg from 'common/assets/images/charts/rolling-stacked-line.svg';
import cumulativeLineSvg from 'common/assets/images/charts/cumulative-line.svg';
import cumulativeStackedLineSvg from 'common/assets/images/charts/cumulative-stacked-line.svg';
import logarithmicBarSvg from 'common/assets/images/charts/logarithmic-bar.svg';
import logarithmicLineSvg from 'common/assets/images/charts/logarithmic-line.svg';
import logarithmicStackedBarSvg from 'common/assets/images/charts/logarithmic-stacked-bar.svg';
import logarithmicStackedLineSvg from 'common/assets/images/charts/logarithmic-stacked-line.svg';
import {TableToggleableMetrics} from 'common/report/funnels/models/constants';

const commonTooltipAttrs = {
  placement: Placement.Left,
  size: DisplaySize.Small,
};

// Helper generators to keep things DRY
function linearTooltipAttrs(imageSrc) {
  return {
    'image-src': imageSrc,
    text: ({t}) => t(`reports.analysis-types.tooltips.linear`),
    ...commonTooltipAttrs,
  };
}

function rollingTooltipAttrs(imageSrc) {
  return {
    'image-src': imageSrc,
    text: ({t}) => t(`reports.analysis-types.tooltips.rolling`),
    ...commonTooltipAttrs,
  };
}

function logarithmicTooltipAttrs(imageSrc) {
  return {
    'image-src': imageSrc,
    text: ({t}) => t(`reports.analysis-types.tooltips.logarithmic`),
    ...commonTooltipAttrs,
  };
}

function cumulativeTooltipAttrs(imageSrc) {
  return {
    'image-src': imageSrc,
    text: ({t}) => t(`reports.analysis-types.tooltips.cumulative`),
    ...commonTooltipAttrs,
  };
}
// end helpers

type TooltipByAnalysisTypeAndChartType = {
  [key in AnalysisType]: {
    [chartType in ChartType]?: TooltipAttrs;
  };
};

export const DEFAULT_STEPS_TABLE_COLUMNS = {
  [TableToggleableMetrics.ConvFirstStep]: false,
  [TableToggleableMetrics.ConvPrevStep]: true,
  [TableToggleableMetrics.Count]: true,
  [TableToggleableMetrics.StatSig]:
    typeof mixpanel === `undefined` ||
    mixpanel.flags?.get_variant_value_sync(`deprecate_funnel_stat_sig`, `control`) === `control`
      ? true
      : false,
  [TableToggleableMetrics.TimeFirstStep]: false,
  [TableToggleableMetrics.TimePrevStep]: true,
};

export const ANALYSIS_TYPE_TOOLTIPS: TooltipByAnalysisTypeAndChartType = {
  [AnalysisType.Linear]: {
    [ChartType.Line]: linearTooltipAttrs(lineSvg),
    [ChartType.Column]: linearTooltipAttrs(columnSvg),
    [ChartType.Bar]: linearTooltipAttrs(barSvg),
    [ChartType.StackedBar]: linearTooltipAttrs(stackedBarSvg),
    [ChartType.StackedLine]: linearTooltipAttrs(stackedLineSvg),
    [ChartType.StackedColumn]: linearTooltipAttrs(stackedColumnSvg),
    [ChartType.Pie]: linearTooltipAttrs(pieSvg),
  },
  [AnalysisType.Rolling]: {
    [ChartType.Line]: rollingTooltipAttrs(rollingLineSvg),
    [ChartType.StackedLine]: rollingTooltipAttrs(rollingStackedLineSvg),
    [ChartType.Column]: rollingTooltipAttrs(columnSvg),
    [ChartType.StackedColumn]: rollingTooltipAttrs(stackedColumnSvg),
  },
  [AnalysisType.Logarithmic]: {
    [ChartType.Line]: logarithmicTooltipAttrs(logarithmicLineSvg),
    [ChartType.Column]: logarithmicTooltipAttrs(columnSvg),
    [ChartType.Bar]: logarithmicTooltipAttrs(logarithmicBarSvg),
    [ChartType.StackedBar]: logarithmicTooltipAttrs(logarithmicStackedBarSvg),
    [ChartType.StackedLine]: logarithmicTooltipAttrs(logarithmicStackedLineSvg),
    [ChartType.StackedColumn]: logarithmicTooltipAttrs(stackedColumnSvg),
  },
  [AnalysisType.Cumulative]: {
    [ChartType.Line]: cumulativeTooltipAttrs(cumulativeLineSvg),
    [ChartType.StackedLine]: cumulativeTooltipAttrs(cumulativeStackedLineSvg),
    [ChartType.Column]: cumulativeTooltipAttrs(columnSvg),
    [ChartType.StackedColumn]: cumulativeTooltipAttrs(stackedColumnSvg),
  },
};
